import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
  OnInit
} from '@angular/core'


import { CartStats } from '../../../cart/models/cart-models'
import { UserContext } from '../../../auth/models/auth';
import { UXPage } from '../../../core/models/ux-page';
import { MenuItem } from '../../models/menu-items';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../reducers';


//declare let ScrollMagic: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
  @ViewChild('nav') nav: ElementRef
  @Input() languages: string[]
  @Input() loggedIn: boolean
  @Input() salesRep: boolean
  @Input() admin: boolean
  @Input() isSimplified = false
  @Input() customerSelected: boolean
  @Input() cart: CartStats
  @Input() currency: string

  @Input() viewMode: string
  @Input() catalogRoute: string
  @Input() logoUrl

  @Input() searchTerm: string
  @Input() onNavigation: string

  @Input() user: UserContext

  @Input() isPagesLoading: boolean
  @Input() pages: UXPage[]
  @Input() menuItems: MenuItem[]
  @Input() navigateUrl: string
  @Input() topMenuStyle: string

  @Output() onSearch = new EventEmitter<string>()
  @Output() onSelectCustomer = new EventEmitter()
  @Output() onItemClick = new EventEmitter<void>()

  showMobileMenu: boolean = false;
  showMobileUserOptions: boolean = false;
  scrollModeEnabled: boolean = false;

  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>)
  {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  ngOnInit() {



  }


  doSearch(term: string) {
    this.onSearch.emit(term)
  }

  selectCustomer() {
    this.onSelectCustomer.emit()
  }

  toggleNavbar() {
    this.showMobileMenu = !this.showMobileMenu;
  }
  toggleMobileUserOptions() {
    this.showMobileUserOptions = !this.showMobileUserOptions;
  }

  itemClick(): void {
    this.onItemClick.emit()
  }
}
